import React from 'react';
import { ITableDataSource } from 'models/table';
import { Grid, Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { Elabels } from 'pages/CaseManagementPage/CasesPage/helpers';
import { EButtonSizes, EButtonVariants } from 'constants/Buttons';
import Button from 'components/atoms/Button';
import { StyledTableCard, StyledTableCardItem } from '../../../styles';

interface INotesTableCard {
  data: ITableDataSource;
  viewAction: (id: string) => void;
  editAction: (id: string) => void;
  deleteAction: (id: string) => void;
  isReadOnly?: boolean;
}

export const NotesTableCard = ({
  data,
  viewAction,
  editAction,
  deleteAction,
  isReadOnly,
}: INotesTableCard) => {
  const { t } = useTranslations();

  return (
    <StyledTableCard container>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.notesName)}</Typography>
        <Typography variant="body2">{data.notesName}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.lastUpdate)}</Typography>
        <Typography variant="body2">{data.lastUpdate}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.lastAuthor)}</Typography>
        <Typography variant="body2">{data.lastAuthor}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem container size={{ xs: 12 }}>
        <Grid>
          <Typography variant="subtitle2">{t(Elabels.actions)}</Typography>
        </Grid>
        <Grid container columnSpacing={2}>
          <Grid size={{ xs: 4 }}>
            <Button
              variant={EButtonVariants.outlined}
              label={t('general.view.label')}
              onClick={() => viewAction(data.id.toString())}
              size={EButtonSizes.small}
              fullWidth
              id="notes_table_card_view-button"
            />
          </Grid>
          {!isReadOnly && (
            <Grid size={{ xs: 4 }}>
              <Button
                variant={EButtonVariants.outlined}
                label={t('general.edit.label')}
                onClick={() => editAction(data.id.toString())}
                size={EButtonSizes.small}
                fullWidth
                id="notes_table_card_edit-button"
              />
            </Grid>
          )}
          {!isReadOnly && (
            <Grid size={{ xs: 4 }}>
              <Button
                variant={EButtonVariants.contained}
                label={t('general.delete.label')}
                onClick={() => deleteAction(data.id.toString())}
                size={EButtonSizes.small}
                fullWidth
                id="notes_table_card_delete-button"
              />
            </Grid>
          )}
        </Grid>
      </StyledTableCardItem>
    </StyledTableCard>
  );
};
